import React, { Component } from "react";
import $ from "jquery";
import { Link } from "react-router-dom";
import { Button, Col, Modal, Row } from "react-materialize";
import StarRatings from "react-star-ratings";

import { CheckAuth, BASE_URL } from "../../Util";
import { trans } from "../../Lang";

class BuyCourseButton extends Component {
  NotCommunityRedeemableContent({ title, website_url }) {
    return (
      <div className="center almost-full">
        <img className="mt-s mb-m" src={BASE_URL + "/img/img-popup.png"} />
        <div className="mb-m">
          <h4 className="center">
            <b>Gabung Komunitas</b>
          </h4>
          Maaf, {trans.course} ini hanya bisa diakses oleh anggota komunitas{" "}
          <b>{title}</b>
          <br />
          Untuk mengetahui informasi lebih lanjut silakan klik tombol di bawah
          ini
        </div>
        <Link
          to={website_url}
          target="_blank"
          className="btn modal-close capitalize"
        >
          Info Lebih Lanjut
        </Link>
        <h4 />
      </div>
    );
  }

  RightAlignedButton(click_function) {
    const default_function = (e) => e.preventDefault();
    return (
      <a
        onClick={click_function ? click_function : default_function}
        className="btn right"
      >
        {trans.enroll}{" "}
        <span className="hide-on-small-only">{trans.course}</span>
      </a>
    );
  }

  RequiredCourseContent({ uuid, title }) {
    return (
      <div className="center almost-full">
        <h4 className="font-light">Perhatian</h4>
        <div className="mb-m">
          Anda perlu menyelesaikan {trans.course} syarat{" "}
          <Link
            className="font-orange strong modal-close"
            to={`/course/${uuid}`}
          >
            {title}
          </Link>{" "}
          untuk mengikuti {trans.course} ini.
        </div>
        <Link
          to={`/course/${uuid}`}
          className="btn modal-close capitalize btn-outline"
        >
          Oke
        </Link>
      </div>
    );
  }

  render() {
    const userdata = CheckAuth();
    const { data, requiredCourse } = this.props;
    //console.log("USERDATA >>> ", userdata);
    //console.log("DATA >>> ", data);

    if (data.communities.length > 0 && !data.community_redeemable) {
      const { title, website_url } = data.communities[0];
      return (
        <Modal
          trigger={
            <a
              className="btn right"
              style={
                userdata.is_businessman === 0
                  ? { marginTop: "1.25rem" }
                  : { marginTop: "auto" }
              }
            >
              {trans.enroll}{" "}
              <span className="hide-on-small-only">{trans.course}</span>I
            </a>
          }
        >
          {this.NotCommunityRedeemableContent({ title, website_url })}
        </Modal>
      );
    }

    // CEK SYARAT KULIAH
    // if (data.price == 0) {
    // if (!requiredCourse || requiredCourse.completed) {
    // 	return this.RightAlignedButton(this.props.onEnroll);
    // } else {
    // 	const { uuid, title } = data.required_course;
    // 	return (
    // 		<Modal trigger={this.RightAlignedButton()}>
    // 			{this.RequiredCourseContent({ uuid, title })}
    // 		</Modal>
    // 	);
    // }
    // }

    return (
      <div>
        <div>
          {/* If Course Not Completed Yet */}
          {!data.completed && (
            <Button
              onClick={this.props.onEnroll}
              className="btn right"
              style={{ background: "#3EA6DA" }}
            >
              Mulai {trans.course}
            </Button>
          )}
        </div>
      </div>
    );
  }
}

export default BuyCourseButton;



// WEBPACK FOOTER //
// ./src/components/Course/components/BuyCourseButton.js